import { Skeleton } from '@syncanix/ui';

import type { ReactElement } from 'react';

/**
 * Suspense fallback while a lazy route chunk loads (A23). Mirrors the A18
 * page-skeleton shape (header line + content blocks) so a slow network shows
 * the same loading language as in-page fetches — not a blank flash.
 */
export function RouteFallback(): ReactElement {
  return (
    <section className="space-y-6 p-6" aria-busy="true">
      <header className="space-y-2">
        <Skeleton className="h-7 w-44 rounded" />
        <Skeleton shape="text" className="w-80" />
      </header>
      <div className="space-y-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} className="h-14 rounded" />
        ))}
      </div>
    </section>
  );
}
